import { render } from "./UnknownPopup.vue?vue&type=template&id=1d45a0a4"
import script from "./UnknownPopup.vue?vue&type=script&lang=js"
export * from "./UnknownPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__